import { hotList, columns, stats } from "@/pages/home/data";

function rankTagColor(tag: string) {
  if (tag === "热") return "bg-primary-500 text-background-50";
  if (tag === "新") return "bg-accent-500 text-background-50";
  if (tag === "荐") return "bg-secondary-500 text-background-50";
  return "hidden";
}

export default function HotSection() {
  return (
    <section id="hot" className="scroll-anchor bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        {/* 栏目卡片带 */}
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-6">
          {columns.map((c) => (
            <a
              key={c.name}
              href="#picks"
              className="group flex flex-col gap-2 rounded-lg bg-background-100 p-4 transition-colors hover:bg-background-200/80"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-700 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
                <i className={c.icon} aria-hidden="true"></i>
              </span>
              <div>
                <p className="text-sm font-bold text-foreground-950">{c.name}</p>
                <p className="text-xs text-foreground-500">{c.count}</p>
              </div>
              <p className="text-xs leading-relaxed text-foreground-600">{c.desc}</p>
            </a>
          ))}
        </div>

        {/* 标题区 */}
        <div className="mt-14 flex flex-col gap-2 md:mt-20 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-2 text-sm font-bold text-primary-600">
              <span className="h-px w-8 bg-primary-500"></span>
              今日热榜
            </div>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              大家都在吃哪些瓜
            </h2>
          </div>
          <a
            href="#picks"
            className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-foreground-700 transition-colors hover:text-primary-600"
          >
            全部深扒内容
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mt-8 grid gap-8 lg:grid-cols-12">
          {/* 排行列表 */}
          <div className="lg:col-span-8">
            <ul className="overflow-hidden rounded-xl border border-background-200 bg-background-100/60">
              {hotList.map((item, idx) => (
                <li key={item.id}>
                  <a
                    href="#picks"
                    className="group flex items-center gap-4 px-4 py-4 transition-colors hover:bg-background-100 md:px-6"
                  >
                    <span className="font-heading text-2xl font-black text-secondary-400 transition-colors group-hover:text-primary-500 md:text-3xl">
                      {item.rank}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex flex-wrap items-center gap-2">
                        <span
                          className={
                            "flex h-5 min-w-[22px] items-center justify-center rounded-full px-1.5 text-[10px] font-bold " +
                            rankTagColor(item.tag)
                          }
                        >
                          {item.tag}
                        </span>
                        <h3 className="truncate text-base font-semibold text-foreground-950 md:text-lg">
                          {item.title}
                        </h3>
                      </div>
                      <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                        <span className="rounded-sm bg-background-200 px-1.5 py-0.5">{item.category}</span>
                      </div>
                    </div>
                    <span className="hidden shrink-0 items-center gap-1 text-sm font-semibold text-foreground-600 sm:flex">
                      <i className="ri-fire-line text-accent-500" aria-hidden="true"></i>
                      {item.heat}
                    </span>
                    {idx === 0 && <span className="sr-only">本期榜首</span>}
                  </a>
                  {idx < hotList.length - 1 && <div className="mx-4 border-t border-background-200/70"></div>}
                </li>
              ))}
            </ul>
          </div>

          {/* 右侧面板 */}
          <div className="lg:col-span-4">
            <div className="rounded-xl bg-foreground-950 p-6 text-background-50 md:p-7">
              <p className="text-xs font-bold uppercase tracking-widest text-accent-400">看吃瓜在数字里</p>
              <div className="mt-5 grid grid-cols-2 gap-4">
                {stats.map((s) => (
                  <div key={s.label} className="rounded-lg bg-background-50/5 p-3">
                    <p className="font-heading text-2xl font-black text-accent-400">{s.value}</p>
                    <p className="mt-1 text-xs text-background-100/70">{s.label}</p>
                  </div>
                ))}
              </div>
              <p className="mt-6 border-l-2 border-primary-500 pl-3 text-sm leading-relaxed text-background-100/85">
                不止看表面热闹，更带你挖背后故事。从事件真相到内幕解析，我们做详细扒皮与细节深挖，把被忽略的线索串起来。
              </p>
              <a
                href="#about"
                className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-accent-400 transition-colors hover:text-accent-300"
              >
                认识编辑部
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}